import { render } from "./HeadMenu.vue?vue&type=template&id=23398c60"
import script from "./HeadMenu.vue?vue&type=script&lang=js"
export * from "./HeadMenu.vue?vue&type=script&lang=js"

import "./HeadMenu.vue?vue&type=style&index=0&id=23398c60&lang=css"

import exportComponent from "C:\\Users\\Administrator\\Downloads\\放射小程序\\后台\\manager\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__